export const STATELY_SORT_DIRECTION = {
    ASC: "ascending",
    DESC: "descending",
};
export const STATELY_SORT_DIRECTION_REVERSE = {
    ascending: "ASC",
    descending: "DESC",
};
